import { resourceReducer } from 'redux-resource';
import { reset, httpStatusCodes } from 'redux-resource-plugins';
import metaReducer from './metaReducer';

const voiceRecords = resourceReducer('voiceRecords', {
  plugins: [reset, metaReducer, httpStatusCodes],
});

export default voiceRecords;

export const getSprintCallRecordsError = (state, subId) =>
  state.requests[`sendSprintCallRecords${subId}`] &&
  state.requests[`sendSprintCallRecords${subId}`].error;

export const getSprintCallRecordsSucceed = (state, subId) =>
  state.resources[`sendSprintCallRecords${subId}`] &&
  state.resources[`sendSprintCallRecords${subId}`].success;
